export class TerminalActions {
    static get Payout(): string {
        return "Payout";
    }

    static get BackToLobby(): string {
        return "BackToLobby";
    }

    static get StartWithCollect(): string {
        return "StartWithCollect";
    }

    static get Autoplay(): string {
        return "Autoplay";
    }

    static get BetOrGamble(): string {
        return "BetOrGamble";
    }

    static get ActionLeft(): string {
        return "ActionLeft";
    }

    static get ActionRight(): string {
        return "ActionRight";
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/TerminalActions.ts
 **/